import { Outlet, useMatch, useParams } from 'react-router-dom'

import { ProcessesProcessCategoryEnum } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { AiOnboardingInterestBanner } from 'modules/processes/components/AiOnboardingInterestBanner'
import { useProcesses } from 'modules/processes/hooks/useProcesses'

import Templates from 'modules/processes/pages/Processes/ProcessesHomePage/Templates'
import Processes from './Processes'

const TemplatePage = () => {
  const { category } = useParams()
  const { search, debouncedSearch, onSearch } = useDebouncedSearch()
  const { navigation } = useNavigation()
  const { loading: processesLoading, processes } = useProcesses({
    name: debouncedSearch,
    categories: [category as ProcessesProcessCategoryEnum],
  })

  const isTemplatesOverview = !!useMatch(`${navigation.processes.template.path}/:category`)
  return (
    <ResponsivePage.Body showHeader={isTemplatesOverview}>
      {category && isTemplatesOverview && (
        <>
          {category === 'onboarding' && <AiOnboardingInterestBanner />}
          <Templates category={category} />
          <Processes
            processes={processes}
            category={category}
            search={search}
            onSearch={onSearch}
            loading={processesLoading}
          />
        </>
      )}
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default TemplatePage
